import { useApp } from '../../app/context';
import './Toasts.css';

/**
 * Notifications stack at the bottom of the screen, gone after a few seconds. Toasts never
 * take a tap: on a phone they lie over the main buttons («Готово!», «Ещё раз!», the room's
 * tools), and in a race a tap anywhere is a jump. Screen readers hear them (aria-live).
 */
export function Toasts() {
  const app = useApp();
  const inGame = app.screen.value === 'game';
  return (
    <div class={`toasts${inGame ? ' toasts--game' : ''}`} role="status" aria-live="polite">
      {app.toasts.toasts.value.map((toast) => (
        <div key={toast.id} class={`toast toast--${toast.tone}`}>
          {toast.text}
        </div>
      ))}
    </div>
  );
}
